var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    className: "upload_svg__upload upload_svg__w-6 upload_svg__h-6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
  })));
}

export default __webpack_public_path__ + "static/media/upload.4e465cb3.svg";
export { SvgUpload as ReactComponent };